<template>
  <div class="qf-table-footer">
    <jw-pagination :total="paginationInfo?.total" :page-size="paginationInfo.pageSize" size="mini" show-total show-jumper show-page-size :page-size-options="paginationInfo.pageSizeOptions" @change="handlePageChange" @page-size-change="handlePageSizeChange" :current="paginationInfo.current" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  pagination: {
    type: Object,
    default: () => {}
  }
});
const paginationInfo = computed(() => ({ ...props.pagination }));
const emits = defineEmits(['pageChange', 'pageSizeChange']);

const handlePageChange = (page) => {
  emits('pageChange', page);
};

const handlePageSizeChange = (pageSize) => {
  emits('pageSizeChange', pageSize);
};
</script>
<style scoped lang="less">
@import './qf-table-footer.less';
</style>
